<script setup lang="ts">
interface MarkdownRenderProps {
  md?: string
  cid?: string
  tag?: string
  theme?: string
  body?: string
}
withDefaults(defineProps<MarkdownRenderProps>(), { md: '', body: '', cid: '' })
</script>

<template>
  <div
    v-bind="$attrs"
    :class="[tag ? tag + ' md' : 'md', theme]"
    v-html="$mdRenderer.render(md)"
  />
</template>

<style scoped>
@reference "../assets/css/main.css";

.md :deep(a) {
  @apply font-bold duration-150;
}

.md :deep(a:hover) {
  @apply text-primary;
}

/* .md p:not(:last) {
  @apply pb-6;
} */
.md :deep(h1) {
  @apply text-4xl mb-3;
}

.md :deep(h2) {
  @apply text-3xl mb-3;
}

.md :deep(h3) {
  @apply text-2xl mb-3;
}

.md :deep(p:not(:last-child)) {
  @apply pb-6;
}

.md :deep(h2) {
  @apply mb-6;
}

.md :deep(ul) {
  @apply list-disc list-outside mb-6;
}
.md :deep(ol) {
  @apply list-decimal list-outside mb-6;
}
.md :deep(li) {
  @apply ml-4 pl-3 pt-2;
}
</style>
